import React from "react";
import { useIntl } from "react-intl";
export function TextLines({ id }) {
    const { formatMessage } = useIntl();
    return (<>
            {formatMessage({ id })
            .split("\n")
            .map((txt, i) => (<span className="block" style={{ minHeight: 15 }} key={i}>
                        {txt}
                    </span>))}
        </>);
}
//# sourceMappingURL=textLines.jsx.map